import axios from 'axios'

interface ApiResponse<T> {
    success: boolean
    data: T
    message?: string
}

export interface GrowthCampaignConfig {
    /** Master switch for the whole campaign (3-day unlimited emails → 8h flash offer). */
    enabled: boolean
    /** Independent switch for just the flash phase. */
    flashOfferEnabled: boolean
    /** Stripe checkout link (90%/first-month coupon) the "$1.49" CTA opens. */
    flashOfferStripeUrl: string
}

export type GrowthCampaignPatch = Partial<GrowthCampaignConfig>

export const growthCampaignApi = {
    getConfig: async (): Promise<GrowthCampaignConfig> => {
        const res = await axios.get<ApiResponse<GrowthCampaignConfig>>('/gluon/billing/growth-campaign')
        return res.data.data
    },

    updateConfig: async (patch: GrowthCampaignPatch): Promise<GrowthCampaignConfig> => {
        const res = await axios.post<ApiResponse<GrowthCampaignConfig>>('/gluon/billing/growth-campaign', patch)
        return res.data.data
    },
}
